import React from 'react'
import "./questionsAnswers.css"

const QuestionsAnswers = () => {
    return (
        <div className="content questionsAnswers">
            <div className="titleMobileDisplay">
                Питања и одговори:
            </div>

            <div className="qa">
                <div className="item">
                    <div className="question">1. Када почиње „Зајечарско части“ наградна игра и до када траје?</div>
                    <div className="answer">Наградна игра „Зајечарско части“ почиње 06. априла 2026. године и траје до 17. маја 2025. године.
                    </div>
                </div>

                <div className="item">
                    <div className="question">2. Где се могу прочитати правила учешћа o наградној игри „Зајечарско части“?</div>
                    <div className="answer">Правила наградне игре „Зајечарско части“ можете прочитати на
                        <a href="https://www.zajecarskoigra.rs" target="_blank"> www.zajecarskoigra.rs</a>.
                    </div>
                </div>

                <div className="item">
                    <div className="question">3. Ко све може да учествује у наградној игри „Зајечарско части“?</div>
                    <div className="answer">Сва пунолетна лица са пребивалиштем у Републици Србији имају право да учествују
                        у Наградној игри, изузев лица запослених код Организатора, маркетиншких агенција које је Организатор
                        ангажовао у промоцији наградне игре, као и чланова њихових најужих породица
                        (супружници, деца, те родитељи и рођена браћа и сестре уколико са њима живе у заједници).
                        Организатор задржава право да, по сопственом нахођењу, изврши мере провере горе наведених чињеница.
                    </div>
                </div>

                <div className="item">
                    <div className="question">4. Да ли и запослени у HEINEKEN Srbija систему имају право учешћа?</div>
                    <div className="answer">Запослени у компанији немају право учешћа у наградној игри. </div>
                </div>

                <div className="item">
                    <div className="question">5. Да ли постоји старосно ограничење за учешће у наградној игри?</div>
                    <div className="answer">Постоје старосна ограничења за учешће у наградној игри.
                        Сви учесници морају бити пунолетни. Организатор задржава право да, изврши мере провере
                        горе наведених чињеница у складу са Правилима наградне игре.
                    </div>
                </div>

                <div className="item">
                    <div className="question">6. Да ли у наградној игри могу да учествују потрошачи који немају електронску адресу?</div>
                    <div className="answer">У овој наградној игри могу учествовати потрошачи који немају електронску адресу,
                        међутим, у том случају, учествују искључиво слањем кода путем СМС поруке.
                        Уколико се учествује путем веб-сајта <a href="https://www.zajecarskoigra.rs" target="_blank">www.zajecarskoigra.rs</a>
                        , потребно је да учесник поседује електронску адресу због верификације добитка и комуникације о преузимању награде.
                    </div>
                </div>

                <div className="item">
                    <div className="question">7. Како изгледа, односно од чега се састоји наградни код?</div>
                    <div className="answer">У питању је код од 8 карактера који чине комбинација слова и бројева.</div>
                </div>

                <div className="item">
                    <div className="question">8. Која све паковања учествују у наградној игри?</div>
                    <div className="answer">У наградној игри учествују промотивна паковања Зајечарско пива, а која су
                        обележена промотивним етикетама које комуницирају информације о наградној игри и промотивним затварачима, и то <br /> <br />
                        - Зајечарско пиво паковано у лименку од 0,5 литара са промотивним затварачима сребрно-црвене боје <br /> <br />
                        - Зајечарско пиво паковано у стаклену повратну боцу од 0,5 литара са промотивним затварачима црвено-беле боје <br /> <br />
                        - Зајечарско пиво паковано у стаклену неповратну боцу од 0,33 литра  са промотивним затварачима црвено-беле боје.
                    </div>
                </div>

                <div className="item">
                    <div className="question">9. Како препознати које је паковање Зајечарског пива промотивно паковање са којим се
                        може учествовати у наградној игри?</div>
                    <div className="answer">Амбалажа промотивних паковања је препознатљива по промотивним етикетама и промотивним затварачима.
                        Промотивни затварачи на боцама су црвено – беле боје, на лименкама сребрно-црвене боје,
                        а етикете комуницирају информације о наградној игри.
                    </div>
                </div>

                <div className="item">
                    <div className="question">10. Купио/ла сам Зајечарско, али испод чепа нема никаквог кода. Да ли тај чеп учествује
                        у наградној игри или не?</div>
                    <div className="answer">Амбалажа промотивних паковања је препознатљива по промотивним етикетама и промотивним затварачима.
                        Промотивни затварачи на боцама су црвено – беле боје, на лименкама сребрно-црвене боје, а етикете комуницирају информације о наградној игри.
                    </div>
                </div>

                <div className="item">
                    <div className="question">11. Која су правила за учествовање у наградној игри?</div>
                    <div className="answer">Како би потрошачи могли да учествују у наградној игри потребно је да: <br /> <br />
                        • Купе промотивно паковање Зајечарско пива: стаклену повратну боцу од 0,5 литара, стаклену неповратну боцу
                        од 0,33 литара или лименку 0,5 литара и пронађу код испод затварача на стакленој повратној боци од 0,5 литара,
                        стакленој неповратној боци од 0,33 литара или лименци од 0,5 литара. Амбалажа промотивних паковања је
                        препознатљива по промотивним етикетама и промотивним затварачима,  који су на боцама црвено – беле боје,
                        на лименкама сребрно-црвене боје, а етикете комуницирају информације о наградној игри. <br /> <br />

                        • Након што потрошач пронађе код испод затварача потребно је исти пошаље путем СМС поруке на број
                        телефона 6600 (слањем ове поруке потрошач потврђује да има 18 или више година и да прихвата правила наградне игре)
                        или путем веб-странице <a href="https://www.zajecarskoigra.rs" target="_blank">www.zajecarskoigra.rs</a>,
                        тако што ће унети датум свог рођења и алгоритам ће аутоматски израчунати
                        да ли потрошач има 18 или више година. Уколико је потрошач пунолетан, може унети  код у предвиђено поље, након чега је
                        потребно да притисне дугме „ПОШАЉИ“. Изнад дугмета „ПОШАЉИ“ стајаће поље које ће потрошач моћи да обележи, а поред
                        поља ће стајати текст “Прихватам правила наградне игре''. Унос кода не може да се комплетира уколико поред поруке
                        у одговарајућем формату учесник не остави и број телефона и електронску адресу који ће служити за његову идентификацију.
                        Потрошачи  су сами одговорни да осигурају да број телефона и електронска адреса које региструју путем веб странице
                        буду исправни, те организатор не сносни никакву одговорност у случају да је дошло до грешке током регистровања
                        броја услед чега награда не може бити додељена, уручена или шта слично. У случају да учесник, који је унео све горе
                        наведене податке, не освоји ниједну награду, сви унети подаци ће бити обрисани одмах по завршетку наградне игре. <br /> <br />

                        • Слањем кода потрошач постаје учесник наградне игре. Учесник (слањем кода) учествује у инстант извлачењу за једну
                        од награда описаних у овим правилима.  Поруке које су послате у другачијој форми од оне која је наведена или на било
                        који начин садржи неправилно унет код, неће се сматрати исправним и неће учествовати у извлачењу <br /> <br />

                        • Одмах након слања исправног кода на горе објашњен начин, учесник добија повратну информацију поруком, да ли је
                        добио неку од награда или не и то: <br /> <br />

                        - путем СМС поруке ако је код послао СМС-ом или <br /> <br />
                        - кроз обавештајно поље на веб страници&nbsp;<a href="https://www.zajecarskoigra.rs" target="_blank">www.zajecarskoigra.rs</a>
                        &nbsp;ако је код послао путем веб странице. <br /> <br />

                        СМС порука се наплаћује учеснику наградне игре по цени основне поруке оператoра и то: <br /> <br />
                        - за кориснике МТС мобилне мреже: 3,6 дин (у цену је урачунат ПДВ) <br />
                        - за кориснике Yettel мобилне мреже: 4,9 дин (у цену је урачунат ПДВ) <br />
                        - за кориснике A1 мобилне мреже: 3,48  дин (у цену је урачунат ПДВ) <br />
                        - за кориснике Globaltel мобилне мреже: 3,48  дин (у цену је урачунат ПДВ) <br /> <br />

                        Оператoри задржавају право на промену стандардне цене СМС поруке која се тарифира крајњем кориснику, сходно својој комерцијалној политици.
                        Организатор не одговара за евентуалну промену наведених цена која настане након објављивања ових правила.
                    </div>
                </div>

                <div className="item">
                    <div className="question">12. Како ћу знати да ли сам добио награду?</div>
                    <div className="answer">Одмах након слања исправног кода учесник добија повратну информацију о статусу његовог кода
                        (да ли је код добитан или не) поруком и то: <br /> <br />
                        - путем СМС поруке ако је код послао СМС-ом или <br /> <br />
                        - кроз обавештајно поље на веб страници&nbsp;<a href="https://www.zajecarskoigra.rs" target="_blank">www.zajecarskoigra.rs</a>&nbsp;ако
                        је код послао путем веб странице. <br /> <br />
                        Када је код добитан, учесник добија и информацију коју награду је освојио
                        (сет за роштиљ, кухињски фрижидер, ваучер од 2000 евра за опремање кухиње, АУТОМОБИЛ ШКОДА ОКТАВИЈА)
                        и да ће бити контактиран у наредна 3 радна дана ради узимања података.
                    </div>
                </div>

                <div className="item">
                    <div className="question">13. Шта се дешава када добијем поруку да сам добио награду?</div>
                    <div className="answer">У СМС или електронској поруци којом је добитник обавештен да је добио одређену награду,
                        биће такође обавештен да ће га контактирати контакт центар у року од 3 радна дана, како би се договорило преузимање награде.
                    </div>
                </div>

                <div className="item">
                    <div className="question">14. Које се све награде деле у оквиру наградне игре?</div>
                    <div className="answer">Награде које се деле учесницима у наградној игри ће бити додељиване на следећи начин: <br /> <br />
                        1. Сваких сат времена - Сет за роштиљ,  <br />
                        2. Сваког дана – Кухињски фрижидер, <br />
                        3. Сваких седам дана - Ваучер од 2000 евра за опремање кухиње, <br />
                        4. Сваких четрнаест дана - АУТОМОБИЛ ШКОДА ОКТАВИЈА.
                    </div>
                </div>

                <div className="item">
                    <div className="question">15. Колики је наградни фонд?</div>
                    <div className="answer">Током трајања наградне игре од 06. априла до 17. маја 2026, учесницима ће бити подељено: <br /> <br />
                        1. 1008 комада Сетова за роштиљ, <br />
                        2. 42 комада Кухињских фрижидера, <br />
                        3. 6 комада Ваучера од 2000 евра за опремање кухиње, <br />
                        4. 3 комада аутомобила ШКОДА ОКТАВИЈА.
                    </div>
                </div>

                <div className="item">
                    <div className="question">16. Да ли се нека од награда може заменити за новац?</div>
                    <div className="answer">Награде се не могу заменити за новац.</div>
                </div>

                <div className="item">
                    <div className="question">17. Може ли се једна награда заменити другом?</div>
                    <div className="answer">Није могуће заменити награде.</div>
                </div>

                <div className="item">
                    <div className="question">18. Како се одређују добитници?</div>
                    <div className="answer">Победници се одређују електронски насумичним избором тренутка у ком се додељује награда,
                        применом алгоритма. Први послати код након насумично одређеног тренутка осваја награду.</div>
                </div>

                <div className="item">
                    <div className="question">19. Уколико је неко освојио награду, да ли тај исти код може да користи у наставку игре?</div>
                    <div className="answer">Не, код који освоји једну награду се елиминише из даљег учешћа у наградној игри.</div>
                </div>

                <div className="item">
                    <div className="question">20. Данас сам послао/ла код и нисам освојио ниједну награду. Да ли сутра или касније могу да користим исти код
                        и да ли ћу имати шансе да добијем награду, уколико је истина да се награде преносе из периода у период ако нема добитника?  </div>
                    <div className="answer">Не. Уколико сте унели код, код више није валидан.</div>
                </div>

                <div className="item">
                    <div className="question">21. Да ли постоји неко ограничење у броју кодова које једна особа може да унесе у току једног сата или једног дана?</div>
                    <div className="answer">Не постоји ограничење у броју послатих кодова.</div>
                </div>

                <div className="item">
                    <div className="question">22. Да ли постоји могућност малверзација, тј. да неко насумично уноси кодове који нису валидни?</div>
                    <div className="answer">Организатор задржава право да дисквалификује учеснике који не поштују правила, или који су преваром
                        или на било који други недозвољен начин или начин који се противи духу сврхе наградне игре,
                        дошли у посед затварача са добитним кодовима. <br /> <br />

                        Коришћење било какве врсте компјутерског кода, вируса, или било чега што може ометати, онемогућити, нанети штету,
                        или злоупотребити учествовање у наградној игри је забрањено. Такви поступци представљају основ за елиминацију учесника.

                    </div>
                </div>

                <div className="item">
                    <div className="question">23. Уколико се награде деле сваких 30 минута, да ли највећу шансу
                        за добијање имају они који играју током првих секунди или минута у одређеном периоду?</div>
                    <div className="answer">Не, шансе за добијање награде не зависе од времена слања кодова.
                        Победници се бирају електронски, применом алгоритма за насумичан избор.</div>
                </div>

                <div className="item">
                    <div className="question">24. Да ли је битно да ли се за наградну игру пријављујем са рачунара или мобилног телефона?</div>
                    <div className="answer">За наградну игру је могуће само да се пријавите путем слања СМС поруке или попуњавањем поља на веб
                        страници <a href="https://www.zajecarskoigra.rs" target="_blank">www.zajecarskoigra.rs</a>. Страници можете приступити
                        путем рачунара или путем моблног телефона.</div>
                </div>

                <div className="item">
                    <div className="question">25. На који начин се подижу награде?</div>
                    <div className="answer">Поклони Сет за роштиљ, Кухињски фрижидер и Ваучер од 2000 евра за опремање кухиње ће бити достављени добитницима
                        путем курирске службе на адресу коју су доставили Организатору, a у року од 90 дана од дана добијања награде.
                        Приликом предаје награда добитник је дужан да потпише документ којим потврђује да је награду преузео и остави
                        као доказ свој потпис и број личне карте. Уколико курир не затекне добитника или пунолетног члана породичног домаћинства
                        добитника чији су подаци достављени Организатору, упутиће добитнику СМС или позив са обавештењем о следећем термину испоруке.
                        У случају поновне неуспеле испоруке добитник ће на исти начин бити обавештен где може да преузме награду.
                        Уколико добитник пропусти да награду преузме у року од 30 дана од дана обавештења губи право на исту и награда остаје недодељена.
                        <br /> <br />

                        Добитницима са пребивалиштем на територији АП Косово и Метохија, награде ће бити уручене у договору са самим добитницима.
                        <br /> <br />

                        Организатор ће добитнику награде аутомобил ШКОДА ОКТАВИЈА организовати уручење кључева у Пивари у Зајечару најкасније
                        у року од 120 дана након завршетка наградне игре уз обавезно присуство тренингу о одговорној конзумацији.
                    </div>
                </div>

                <div className="item">
                    <div className="question">26. Шта уколико нисам у могућности да присуствујем уручењу кључева?</div>
                    <div className="answer">У оваквом случају у договору са организатором биће договорен нови термин уручења кључева.</div>
                </div>

                <div className="item">
                    <div className="question">27. Да ли је могуће неком уступити награде?</div>
                    <div className="answer">Награде се не могу преносити на друга лица. Након регистрације на сајту добитник ће добити повратни
                        е-маил који ће му служити као потврда о добијању награде. Након регистрације више неће бити могуће мењати податке о добитнику награде.
                        Такође, приликом освајања награде путем СМС-а, након остављања података контакт центру неће бити могуће изменити податке о добитнику.
                    </div>
                </div>

                <div className="item">
                    <div className="question">28. Шта се дешава уколико добитник не преузме награду у назначеном термину?</div>
                    <div className="answer">Уколико добитник не преузме награду у договореном термину губи право на награду и та награда остаје недодељена.</div>
                </div>

                <div className="item">
                    <div className="question">29. Да ли награду може освојити малолетно лице?</div>
                    <div className="answer">Сва наша комуникација усмерена је искључиво на пунолетна лица.
                        Правилима наградне игре дефинисано је да малолетна лица не могу учестовати у наградној игри.
                    </div>
                </div>

                <div className="item">
                    <div className="question">30. Да ли је неопходно да се чувају чепови са боца и лименке са кодовима?</div>
                    <div className="answer">Добитници су дужни да чувају затвараче са добитним кодовима до уручења поклона.
                        Добитне затвараче којим су освојили награде ће предати организатору искључиво у случају да то организатор од њих затражи.
                    </div>
                </div>

                <div className="item">
                    <div className="question">31. Где је могуће видети списак добитника и списак подељених награда?</div>
                    <div className="answer">Уколико вам је потребан списак добитника награда, потребно је да контактирате Министарство финансија
                        – управа за игре на срећу. У циљу заштите података, добитници неће бити јавно објављивани.
                        Учесници се у сваком тренутку, путем веб
                        странице <a href="https://www.zajecarskoigra.rs" target="_blank">www.zajecarskoigra.rs</a> могу информисати да ли је
                        у одређеном циклусу од седам дана већ додељена награда, Ваучер од 2000 евра за опремање кухиње и да ли је у циклусу
                        од четрнаест дана већ додељена награда, аутомобил ШКОДА ОКТАВИЈА. Обавештење о додељеним наградама у циклусу од пет или
                        десет дана ће бити постављено на поменутој web страници најкасније до краја дана у ком је додељена награда из датог циклуса.

                    </div>
                </div>

                <div className="item">
                    <div className="question">32. Ко је одговоран за предају награда?</div>
                    <div className="answer">За предају награда гарантује организатор. Одговорност организатора према добитницима престаје након чина
                        испоруке добијене награде која одговара опису награде из правила.</div>
                </div>

                <div className="item">
                    <div className="question">33. Коме да се обратим ако имам неку примедбу у вези са наградом?</div>
                    <div className="answer">У случају примедби на квалитет и употребну вредност награда, добитници ће се обратити правним
                        лицима која су награде обезбедили у складу са прописима о заштити потрошача. Одговорност Организатора према добитницима,
                        у вези са квалитетом награда, престаје након чина испоруке/предаје добијене награде која одговара опису награде из Правила наградне игре.
                    </div>
                </div>

                <div className="item">
                    <div className="question">34. Да ли ће моји подаци бити јавно објављени?</div>
                    <div className="answer">Лични подаци добитника ће бити прослеђени и курирској служби ради доставе награда.
                        Лични подаци добитника могу бити прослеђени и надлежним државним органима када је то потребно и када се то
                        од Организатора тражи (нпр. Управа за игре на срећу, Пореска управа).
                        <br /> <br />

                        Добитници недељних награда ће можда бити фотографисани за сврху промоције бренда Зајечарско. У том случају,
                        биће им понуђен посебан документ – сагласност, чијим потписивањем пристају на употребу њихових фотографија у горе наведене сврхе.

                    </div>
                </div>

                <div className="item">
                    <div className="question">35. Ко плаћа порез на награде?</div>
                    <div className="answer">Организатор ће сносити трошкове пореза на добитке од игара на срећу.</div>
                </div>

                <div className="item">
                    <div className="question">36. Сцепецификација сета за роштиљ ?</div>
                    <div className="answer">Сет за роштиљ је награда коју можете освојити на сваких сат времена и састоји се из: <br /> <br />

                        • Три роштиљска елемента <br /> <br />
                        - хватаљка за роштиљ,
                        - виљушка за роштиљ и
                        - шпатула за роштиљ <br /> <br />
                        • Футроле за роштиљске елементе
                    </div>
                </div>

                <div className="item">
                    <div className="question">37. Сцепецификација кухињског фрижидера ?</div>
                    <div className="answer">Кухињски фрижидер је награда коју можете освојити сваког дана. <br /> <br />

                        Самостојећи кухињски фрижидер са замрзивачем робне марке LG. <br /> <br />
                        Модел GBV22L0EPY <br /> <br />
                        Висина: 203цм <br /> <br />
                        Ширина: 59,5цм <br /> <br />
                        Дубина: 68,2цм <br /> <br />
                        Боја: Сива <br /> <br />
                        Енергетски разред: Е <br /> <br />
                        Укупна запремина: 387l  <br /> <br />
                        Запремина фрижидера: 277l <br /> <br />
                        Запремина замрзивача/коморе: 110l <br /> <br />
                    </div>
                </div>

                <div className="item">
                    <div className="question">38. Спецификација ваучера за опремање кухиње у износу од 2000 евра?</div>
                    <div className="answer">Ваучер од 2000 евра за опремање кухиње се може искористити до 31.12.2026. године.
                        Овај ваучер се може искористити за куповину робе у објектима Техноманија, Техномедиа и Виторог. <br />
                        Целокупна понуда се може видети на
                        сајту: <a href="https://www.giftoncard.eu/zajecarsko-nagradna-igra" target="_blank">https://www.giftoncard.eu/zajecarsko-nagradna-igra</a>.
                        Ваучер се може користити за више различитих куповина до укупног износа од 2000 евра.
                        Уколико куповина прелази наведени износ, добитници сносе разлику.
                    </div>
                </div>

                <div className="item">
                    <div className="question">39. Спецификација аутомобила ШКОДА ОКТАВИЈА?</div>
                    <div className="answer">
                        • Врста: Путничко  <br />
                        • Марка: Шкода  <br />
                        • Модел: Октавија А8 Селекшн 1.5ТСИ 6Г 85кв/115кс <br />
                        • Код возила: PV3DA5 <br />
                        • Земља порекла: Република Чешка  <br />
                        • Година производње: 2026 <br />
                        • Број врата: 5 <br />
                        • Број места за седење: 5 <br />
                        • Боја возила: Велвет црвена металик - К1К1 <br /> <br />

                        <b>МОТОР</b> <br /> <br />

                        • Број цилиндара: 4 <br />
                        • Погонска осовина: предња <br />
                        • Укупна запремина (cm³): 1498 <br />
                        • Максимална снага Kw(KS): 85 <br />
                        • Максимални обртни моменат(Nm): 220/1500-3000  <br />
                        • Мењач: мануелни, 6 степени преноса + Р <br />
                        • Максимална брзина(km/h): 203 <br />
                        • Гориво: БМБ 95 <br />
                        • Ниво екологије: ЕУРО 6 <br />
                        • Емисија CO2(g/km):119 <br /> <br />

                        <b>ПНЕУМАТИЦИ</b> <br /> <br />
                        • Пнеуматици: 205/60  Р16 <br /> <br />

                        <b>ПОТРОШЊА ГОРИВА (литара/100 km)</b> <br /> <br />
                        • Градска: 7.1 <br />
                        • Ванградска: 4.5 <br />
                        • Комбинована: 5.2 <br />
                        • Резервоар за гориво (литара): 45 <br /> <br />

                        <b>ДИМЕНЗИЈЕ</b> <br /> <br />
                        • Дужина(mm): 4698 <br />
                        • Ширина(mm): 1829 <br />
                        • Висина(mm): 1471 <br />
                        • Међуосовинско растојање(mm): 2669 <br />
                        • Запремина пртљажника (литара): 600 <br /> <br />

                        <b>ТЕЖИНА</b> <br /> <br />
                        • Тежина празног возила (kg): 1351

                    </div>
                </div>

                <div className="item">
                    <div className="question">40. Имам проблем са пријавом кода на сајту. Шта да радим?</div>
                    <div className="answer">У случају да имате проблем са пријавом кода на сајту, молим вас позовите контакт центар на број
                        0800/ 003 337 или пошаљите e-мејл са упитом на адресу: kontakt@zajecarskoigra.rs.
                    </div>
                </div>

                <div className="item">
                    <div className="question">41. Колики је максималан број награда који учесник може освојити?</div>
                    <div className="answer">Број награда који учесник може освојити у току трајања наградне игре није ограничен, осим у случају награде
                        која се додељује на седам дана – ВАУЧЕР ОД 2000 ЕВРА ЗА ОПРЕМАЊЕ КУХИЊЕ и награде која се додељује на
                        четрнаест дана – аутомобил ШКОДА ОКТАВИЈА. Један учесник може освојити само једну награду која се
                        додељује на седам дана и само једну награду која се додељује на четрнаест дана .
                    </div>
                </div>

                <div className="item">
                    <div className="question">42. Колики је максималан број валидних кодова који учесник може да унесе?</div>
                    <div className="answer">Не постоји ограничење у броју унетих кодова које један учесник може унети током трајања наградне игре.</div>
                </div>

                <div className="item">
                    <div className="question">43. Да ли наградна игра може да се прекине пре назначеног датума?</div>
                    <div className="answer">Наградна игра може бити прекинута у случају више силе
                        (околности које Организатор није могао предвидети нити на њих утицати), укључујући немогућност Организатора
                        услед разлога који су независни у односу на његову вољу да води наградну игру.
                        Организатор ће обавестити потрошаче о евентуалном прекиду наградне игре и разлозима путем дневног листа који
                        се дистрибуира на територији целе Републике. У случају прекида из горе наведеног разлога, Организатор неће бити у обавези
                        да учесницима накнади било какве трошкове који се односе на учествовање у наградној игри.
                    </div>
                </div>

                <div className="item">
                    <div className="question">44. Да ли негде могу да видим како награде изгледају?</div>
                    <div className="answer">Награде можете погледати на интернет
                        адреси <a href="https://www.zajecarskoigra.rs" target="_blank">www.zajecarskoigra.rs</a>
                    </div>
                </div>

                <div className="item">
                    <div className="question">45. Ко је задужен да испрати регуларност наградне игре?</div>
                    <div className="answer">Организатор ће у року од 30 дана од завршетка наградне игре доставити Управи за игре на срећу,
                        извештај о резултатима наградне игре. <br /> <br />

                        Регуларност одвијања наградне игре ће пратити комисија коју чине следећи запослени код Организатора: <br /> <br />

                        - Дарко Миловановић, Маркетинг менаџер, <br />
                        - Стефан Јовић, Менаџер групе брендова и   <br />
                        - Душан Вранић, Старији бренд менаџер

                    </div>
                </div>

            </div>
        </div >
    )
}

export default QuestionsAnswers